import { UIActionType } from "../action-types/UIActionType";

export const resetUIData = () => (dispatch) => {
  dispatch({
    type: UIActionType.RESET_UI_DATA,
  });
};

export const setTheme = (theme) => (dispatch) => {
  dispatch({
    type: UIActionType.SET_THEME,
    payload: theme,
  });
};

export const setSnackbar =
  (details, open = true) =>
  (dispatch) => {
    dispatch({
      type: UIActionType.SET_SNACKBAR,
      payload: { ...details, open: open },
    });
  };

export const setLoading = (loading) => (dispatch) => {
  dispatch({
    type: UIActionType.SET_LOADING,
    payload: loading,
  });
};

export const setIsDataFetched = (loading) => (dispatch) => {
  dispatch({
    type: UIActionType.SET_IS_DATA_FETCHED,
    payload: loading,
  });
};

// temp actions

export const addRentedNft = (nft) => (dispatch) => {
  dispatch({
    type: "ON_BORROW",
    payload: nft,
  });
};

export const addLendedNft = (nft) => (dispatch) => {
  dispatch({
    type: "ON_LEND",
    payload: nft,
  });
};
